import React, { Fragment } from 'react'
import { Dropdown } from 'react-bootstrap'
import { isPresent } from 'lodash'
import CopyButton from 'UI/CopyButton'
import AssetNameWithLabel from 'FoundationalComponents/AssetNameWithLabel'

const Menu = ({ children, style = {} }) => (
  <Dropdown>
    {children}
  </Dropdown>
)

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a href="" ref={ref} className='link-sub-menu__button button__link' onClick={(e) => { e.preventDefault(); onClick(e); }}>
    {children}
    &#x25bc;
  </a>
));

const MenuButton = ({ text, children, textToCopy = text, style = {}, label }) => (
  <Fragment>
    <Dropdown.Toggle as={CustomToggle} id={`dropdown-${text}`}>
      {children || (isPresent(label) ? <AssetNameWithLabel name={text} label={label} /> : text)}
    </Dropdown.Toggle>

    {text && <CopyButton {...{ text: textToCopy }} />}
  </Fragment>
)

const MenuDropdown = ({ children, style = {} }) => (
  <Dropdown.Menu>
    {children}
  </Dropdown.Menu>
)

const MenuItem = ({ text, href, children, style = {} }) => (
  <Dropdown.Item className='link-sub-menu__item' {...{ style, href }}>
    {children || <MenuLink {...{ text, href }} />}
  </Dropdown.Item>
)

const MenuLink = ({ text, href, children, style = {} }) => (
  <a style={{ padding: 0, ...style }} className='button__link' target='_blank' {...{ href }}>
    {children || text || href}
  </a>
)

export { Menu, MenuButton, MenuItem, MenuDropdown, MenuLink }
